import React from "react";
import { FaListAlt, FaCreditCard, FaMoneyBillWave } from "react-icons/fa";

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      title: "Select a Plan",
      description:
        "All plans are worth buying! Choose from a variety of plans - We have Lite, Standard and Premium.",
      icon: <FaListAlt className="text-yellow-400 text-3xl" />,
    },
    {
      id: 2,
      title: "Pay the Entry Fee",
      description:
        "Hassle-free online entry fee payment and instant subscription option for an engagement process to optimize your time.",
      icon: <FaCreditCard className="text-green-500 text-3xl" />,
    },
    {
      id: 3,
      title: "Solve & Get Paid",
      description:
        "We'll help you be a smart earner from day one. Read, solve surveys and get paid. Repeat!",
      icon: <FaMoneyBillWave className="text-indigo-500 text-3xl" />,
    },
  ];

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-indigo-50 font-sans">
      <div className="max-w-90vw mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-10">
          How It Works
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div
              key={step.id}
              className="flex flex-col items-center bg-white rounded-lg shadow-lg p-6 text-center space-y-4"
            >
              <div className="flex items-center justify-center h-16 w-16 rounded-full bg-white shadow-inner">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-800">
                {step.title}
              </h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
